export default {
      id: "pay_ya-usage",
      viewBox: "0 0 60 20",
      url: __webpack_public_path__ + "sprite.svg#pay_ya",
      toString: function () {
        return this.url;
      }
    }